"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderCartClickDL } from "./HeaderAnalyticsFunction";

interface HeadercartProps {
  headercart?: {
    ctaInNewTab: string;
    ctaLink: string;
    defaultCount: string;
    heading: string;
    maxCount: string;
    showOnApp: string;
    showOnWeb: string;
  };
}

const Cart: React.FC<HeadercartProps> = ({ headercart }) => {
  const cartUrl = headercart?.ctaLink ?? "";
  const heading = headercart?.heading ?? "";
  const openInNewTab = headercart?.ctaInNewTab === "true";

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    // Track analytics before navigation
    handleHeaderCartClickDL(heading, cartUrl);

    // Navigate after analytics completes
    if (openInNewTab) {
      window.open(cartUrl, "_blank");
    } else {
      window.location.href = cartUrl;
    }
  };

  return (
    <BFLLink
      href={cartUrl}
      aria-label={heading}
      onClick={handleClick}
      className="order-2 mx-0 my-0 flex flex-col items-center px-2 pt-[14px] pb-[30px] hover:bg-[#001326] md:order-3"
    >
      <i className="icomoon text-2xl before:content-['\e95f']" data-testid="cart-icon"></i>
      <span className="hidden text-xs leading-[14px] md:!block" data-testid="cart-heading">
        {heading}
      </span>
    </BFLLink>
  );
};
export default Cart;
